import React from "react";
import "../components.css"; // Ensure this CSS is correctly imported

const Spinner = () => (
    <div className="loading-spinner">
        <div className="circle"></div>
    </div>
);

export default Spinner;
